'use client'

import { useEffect } from 'react'

import { misdirectedPasswordLink } from '@/lib/auth/password-link'

/**
 * Sends a password link that landed on the wrong page to the set-password page.
 *
 * In the root layout because it can land anywhere: on the Site URL, behind the
 * redirect from an old path, on /login after the proxy turned a visitor without
 * a session away. The fragment survives each of those redirects, so it is still
 * there to be read. Why it lands elsewhere at all: misdirectedPasswordLink.
 */
export function PasswordLinkForwarder(): null {
  useEffect(() => {
    const target = misdirectedPasswordLink(window.location.pathname, window.location.hash)
    // replace, not assign: the page the link fell onto is not one to come back to.
    if (target !== null) window.location.replace(target)
  }, [])
  return null
}
